import styled from "styled-components";

const MAX_HEIGHT_EXPANDED = "1000px";
const BILL_ICON_SIZE = "20px";

interface CollapsibleStyleProps {
    isExpanded?: boolean;
    currentRotation?: number;
}

export const HeaderButton = styled.button`
    position: relative;
    width: 100%;
    background: transparent;
`;

export const HeaderRow = styled.div({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    transition: "all 0.4s ease",
});

export const HeaderLeft = styled.div({
    display: "flex",
    alignItems: "flex-start",
});

export const HeaderIconWrapper = styled.div(({ theme }) => ({
    width: BILL_ICON_SIZE,
    height: BILL_ICON_SIZE,
    marginRight: theme.spacing.small,
    flexShrink: 0,
}));

export const HeaderTitleBlock = styled.div({
    display: "flex",
    flexDirection: "column",
});

export const HeaderTitleRow = styled.div({
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
});

export const HeaderInfoText = styled.p(({ theme }) => ({
    margin: `${theme.spacing.xxxSmall} 0 0`,
    marginLeft: theme.spacing.x16,
}));

export const UpsellChipWrapper = styled.div<CollapsibleStyleProps>(({ theme, isExpanded }) => ({
    display: "grid",
    gridTemplateRows: isExpanded ? 0 : "1fr",
    opacity: isExpanded ? 0 : 1,
    margin: isExpanded
        ? 0
        : `${theme.spacing.xSmall} calc(${theme.spacing.xSmall} * -1) calc(${theme.spacing.xxSmall} * -1) calc(${theme.spacing.xSmall} * -1)`,
    overflow: isExpanded ? "hidden" : "visible",
    pointerEvents: isExpanded ? "none" : "auto",
    transition: "grid-template-rows 0.3s ease-in-out, opacity 0.6s ease-in-out, margin 0.3s ease-in-out",
    "& > *": { minHeight: 0 },
}));

export const UpsellChip = styled.div<CollapsibleStyleProps>(
    ({ theme }) => ({
        position: "relative",
        display: "flex",
        gap: `calc(${theme.spacing.xxxSmall} + ${theme.spacing.xxSmall})`,
        backgroundColor: theme.colors[theme.colorMode].border_Tertiary,
        padding: `${theme.spacing.xSmall} ${theme.spacing.small}`,
        borderRadius: theme.cornerRadius.small,
        alignItems: "center",
        fontSize: "12px",
        lineHeight: "16px",
    }),
    ({ theme }) => `
        &::after {
            content: "";
            position: absolute;
            top: calc(0px - (${theme.spacing.xxxSmall} + ${theme.spacing.xxSmall}));
            /* arrow aligns with the right edge of the bill icon */
            left: calc(${theme.spacing.medium} + ${BILL_ICON_SIZE} + ${theme.spacing.small});
            height: ${theme.spacing.small};
            width: ${theme.spacing.small};
            background: ${theme.colors[theme.colorMode].border_Tertiary};
            clip-path: polygon(0% 0%, 100% 100%, 0% 100%);
            transform: rotate(135deg);
            border-radius: 0 0 0 4px;
        }
    `,
    ({ isExpanded }) =>
        isExpanded && {
            opacity: 0,
            transition: "opacity 0.3s ease-in-out, all 0.3s ease-in-out",
        },
);

export const UpsellChipIconWrapper = styled.div({
    width: "20px",
    height: "20px",
    flexShrink: 0,
});

export const CollapseContent = styled.div<CollapsibleStyleProps>(
    {
        maxHeight: 0,
        overflow: "hidden",
        opacity: 0,
        transition: "max-height 0.6s cubic-bezier(0.4, 0.0, 0.2, 1), opacity 0.6s ease-in-out",
    },
    ({ isExpanded }) =>
        isExpanded && {
            maxHeight: MAX_HEIGHT_EXPANDED,
            opacity: 1,
            overflow: "unset",
        },
);

export const CollapseContentSeparator = styled.div(({ theme }) => ({
    height: "1px",
    marginTop: theme.spacing.medium,
    marginBottom: `calc(${theme.spacing.small} + ${theme.spacing.xxxSmall})`,
    position: "relative",

    "::before": {
        content: "''",
        position: "absolute",
        top: "0",
        right: `calc(${theme.spacing.medium} * -1)`,
        bottom: "0",
        left: `calc(${theme.spacing.medium} * -1)`,
        backgroundColor: theme.colors[theme.colorMode].border_Tertiary,
    },
}));
